import React from "react";

import Lamina21img1 from "../images/lamina21img1.png";
import Lamina21img2 from "../images/lamina21img2.png";
import Lamina21text from "../images/lamina21texto.png";
import Lamina21act from "../images/lamina21act.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  green: {
    color: theme.palette.green.main,
    borderColor: theme.palette.green.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina21 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 21: Las migraciones"
        meta={[
          {
            property: "og:title",
            content: "Lámina 21: Las migraciones",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Por diversos motivos, las personas dejamos nuestro lugar de origen para vivir en otro lugar.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="21" color="green" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Title title="Las migraciones" color="green" />
            <p>
              Por diversos motivos, las personas dejamos nuestro lugar de origen
              para vivir en otro lugar; a eso llamamos migración. Seguramente,
              conocemos personas que vienen de otros lugares o nosotros mismos
              hemos tenido la experiencia de migrar.
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina21text} alt="Las migraciones" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>Entrevista a una persona adulta y a una niña o niño.</strong>
          <br></br>Llena las siguientes fichas:
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina21img1} alt="Actividad" />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <img src={Lamina21img2} alt="Actividad" />
          </Grid>
        </Grid>
        <p>
          <strong>Ahora responde de manera escrita o graba un audio:</strong>
        </p>
        <ul>
          <li>¿Qué respuesta te llamó la atención? ¿Por qué?</li>
          <li>
            ¿Tus entrevistados conocen sobre el lugar de origen de su familia?
            ¿Por qué?
          </li>
          <li>
            ¿Por qué será importante conocer los orígenes de papá, mamá y de
            todos nuestros familiares?
          </li>
        </ul>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>Lee estas historias y reflexiona.</strong>
        </p>
        <img src={Lamina21act} alt="Actividad" />
        <p>
          <strong>
            Conversa con alguien de tu familia sobre las siguientes preguntas y
            escribe o graba tus respuestas.
          </strong>
        </p>
        <ul>
          <li>
            ¿Por qué se debe acoger a las personas que vienen de otros lugares?
          </li>
          <li>¿Qué le dirías a una persona que viene de otro lugar?</li>
          <li>
            ¿Qué acciones podrías hacer para valorar la diversidad en tu
            entorno?
          </li>
        </ul>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-21.pdf"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.green }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 21: Las migraciones'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La equidad de género en el Perú"
        anteriorEnlace="/lamina-1-20"
        siguiente="Las lenguas del Perú"
        siguienteEnlace="/lamina-1-22"
      />
    </>
  );
};

export default Lamina21;
